import React, { useState } from 'react';
import moment from 'moment';
import FontAwesomeIcon from 'src/components/Icon';
import { IAvailableServiceTimeDay } from 'src/services/api/UserManagement/apiContracts';
import './service-request-timeslot-picker.scss';

interface ServiceRequestTimeslotPickerProps {
  availableServiceTimes: IAvailableServiceTimeDay[];
  setFormData: (formData: { scheduledAt: string }) => void;
}

interface SelectedSlotPosition {
  dayIndex: number;
  slotIndex: number;
}

const SLOT_TIME_FORMAT: string = 'YYYY-MM-DD HH:mm A';

const ServiceRequestTimeslotPicker = ({
  availableServiceTimes,
  setFormData,
}: ServiceRequestTimeslotPickerProps) => {
  const [selectedSlotPosition, setSelectedSlotPosition] =
    useState<SelectedSlotPosition | null>(null);

  const isSelected = (dayIndex: number, slotIndex: number): boolean =>
    selectedSlotPosition?.dayIndex === dayIndex &&
    selectedSlotPosition?.slotIndex === slotIndex;

  const slotClassName = (dayIndex: number, slotIndex: number): string =>
    isSelected(dayIndex, slotIndex) ? 'picker-slot is-selected' : 'picker-slot';

  const onSlotClick = (dayIndex: number, slotIndex: number, slot: string) => {
    setSelectedSlotPosition({ dayIndex, slotIndex });
    setFormData({ scheduledAt: slot });
  };

  return (
    <div className="service-request-timeslot-picker">
      <div className="picker-title">Open timeslots</div>
      <div>
        {availableServiceTimes.map(
          (availableServiceTime: IAvailableServiceTimeDay, dayIndex: number) => (
            <div key={dayIndex} className="picker-day-group">
              <div className="picker-day">
                {availableServiceTime.dayOfWeek}
              </div>
              <div className="picker-slots">
                {availableServiceTime.slots.map(
                  (slot: string, slotIndex: number) => (
                    <button
                      key={slotIndex}
                      className={slotClassName(dayIndex, slotIndex)}
                      onClick={(event: React.MouseEvent) => {
                        event.preventDefault();
                        onSlotClick(dayIndex, slotIndex, slot);
                      }}
                    >
                      <div className="picker-bullet">
                        <FontAwesomeIcon glyph="check" weight="regular" />
                      </div>
                      <div className="picker-slot-details">
                        <div className="picker-slot-date">
                          {moment(slot, SLOT_TIME_FORMAT).format('MMMM D')}
                        </div>
                        <div className="picker-slot-time">
                          {moment(slot, SLOT_TIME_FORMAT).format('h:mm A')}
                        </div>
                      </div>
                    </button>
                  )
                )}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ServiceRequestTimeslotPicker;